<template>
    <div id="streamProxyList">
        <el-container>
            <el-header>
                <uiHeader></uiHeader>
            </el-header>
            <el-main>
                <div style="background-color: #FFFFFF; margin-bottom: 1rem; position: relative; padding: 0.5rem; text-align: left;">
                    <span style="font-size: 1rem; font-weight: bold;">拉流代理列表</span>
                </div>
                <devicePlayer ref="devicePlayer"></devicePlayer>
                <el-table :data="streamProxyList" :span-method="objectSpanMethod" border style="width: 100%" :height="winHeight">
                    <el-table-column prop="name" label="名称" align="center" show-overflow-tooltip />
                    <el-table-column prop="ip" label="流应用名" align="center" show-overflow-tooltip />
                    <el-table-column prop="session_id" label="流ID" align="center" show-overflow-tooltip />
                    <el-table-column label="流地址" width="400" align="center" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div slot="reference" class="name-wrapper">
                                <el-tag size="medium">
                                    <i class="cpoy-btn el-icon-document-copy" title="点击拷贝" v-clipboard="scope.row.stream_url" @success="$message({type:'success', message:'成功拷贝到粘贴板'})"></i>
                                    {{scope.row.stream_url}}
                                </el-tag>
                                <!-- <el-tag size="medium" v-if="scope.row.type != 'default'">
                                    <i class="cpoy-btn el-icon-document-copy" title="点击拷贝" v-clipboard="scope.row.rtsp_url" @success="$message({type:'success', message:'成功拷贝到粘贴板'})"></i>
                                    {{scope.row.rtsp_url}}
                                </el-tag> -->
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="类型" width="100" align="center">
                        <template slot-scope="scope">
                            <div slot="reference" class="name-wrapper">
                                <el-tag size="medium">{{getTypeString(scope.row.type)}}</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="total_reader_count" label="人数" align="center" show-overflow-tooltip />
                </el-table>
                <el-pagination style="float: right" @size-change="handleSizeChange" @current-change="currentChange" :current-page="currentPage" :page-size="step" :page-sizes="[15, 25, 35, 50]" layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </el-main>
        </el-container>
    </div>
</template>

<script>
import devicePlayer from "./dialog/devicePlayer.vue";
import uiHeader from "./UiHeader.vue";
export default {
    name: "streamProxyList",
    components: {
        devicePlayer,
        uiHeader,
    },
    data() {
        return {
            streamProxyList: [],
            currentPusher: {}, //当前操作设备对象
            updateLooper: 0, //数据刷新轮训标志
            currentDeviceChannelsLenth: 0,
            winHeight: window.innerHeight - 250,
            currentPage: 1,
            step: 15,
            total: 0,
            getListLoading: false,
            startBtnLaoding: false,
        };
    },
    computed: {},
    mounted() {
        this.initData();
        this.updateLooper = setInterval(this.initData, 100000);
    },
    destroyed() {
        this.$destroy("videojs");
        clearTimeout(this.updateLooper);
    },
    methods: {
        initData: function () {
            this.getStreamProxyList();
        },
        currentChange: function (val) {
            this.currentPage = val;
            this.getStreamProxyList();
        },
        handleSizeChange: function (val) {
            this.step = val;
            this.getStreamProxyList();
        },
        getStreamProxyList: function () {
            let that = this;
            this.getListLoading = true;
            this.$axios({
                method: "get",
                url: `/api/mediaserver/proxy/list`,
                params: {
                    page: that.currentPage,
                    step: that.step,
                    token: this.$cookies.get("session").token
                },
            })
                .then(function (res) {
                    console.log("data " + JSON.stringify(res.data));
                    that.total = res.data.total;
                    that.streamProxyList = that.processData(res.data.data);
                    that.getListLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    that.getListLoading = false;
                });
        },
        getTypeString: function (type) {
            // console.log("type");
            if (type == 0) {
                return "实时播放";
            } else if (type == 1) {
                return "历史回放";
            } else if (type == 2) {
                return "下载";
            } else {
                return "未知";
            }
        },
        processData: function (data) {
            console.log("process data");
            let getData = [];
            data.forEach((v, index) => {
                if (v.hls_url.length) {
                    // tmp_data["stream_url"] = v.hls_url;
                    getData.push({
                        name: v.name,
                        ip: v.ip,
                        session_id: v.session_id,
                        total_reader_count: v.total_reader_count,
                        type: v.type,
                        start_time: v.start_time,
                        stream_url: v.hls_url,
                    });
                }
                if (v.rtsp_url.length) {
                    // tmp_data["stream_url"] = v.rtsp_url;
                    // let tmp = tmp_data;
                    getData.push({
                        name: v.name,
                        ip: v.ip,
                        session_id: v.session_id,
                        total_reader_count: v.total_reader_count,
                        type: v.type,
                        start_time: v.start_time,
                        stream_url: v.rtsp_url,
                    });
                }
                if (v.httpflv_url.length) {
                    getData.push({
                        name: v.name,
                        ip: v.ip,
                        session_id: v.session_id,
                        total_reader_count: v.total_reader_count,
                        type: v.type,
                        start_time: v.start_time,
                        stream_url: v.httpflv_url,
                    });
                }
            });
            return getData;
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex !== 2) {
                if (rowIndex % 2 === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1,
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    };
                }
            }
        },
    },
};
</script>

<style>
.videoList {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
}

.video-item {
    position: relative;
    width: 15rem;
    height: 10rem;
    margin-right: 1rem;
    background-color: #000000;
}

.video-item-img {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    height: 100%;
}

.video-item-img:after {
    content: "";
    display: inline-block;
    position: absolute;
    z-index: 2;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 3rem;
    height: 3rem;
    background-image: url("../assets/loading.png");
    background-size: cover;
    background-color: #000000;
}

.video-item-title {
    position: absolute;
    bottom: 0;
    color: #000000;
    background-color: #ffffff;
    line-height: 1.5rem;
    padding: 0.3rem;
    width: 14.4rem;
}
.cpoy-btn {
    cursor: pointer;
    margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/StreamProxyList.vue